import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {TenantService} from './tenant.service';
import {from, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ProtectedResourceAccess} from '../models/protected-resource-access.model';
import { Firestore, doc, setDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ProtectedResourceService {

  constructor(
    private http:HttpClient,
    private tenant: TenantService,
    private firestore: Firestore) {

  }


  loadProtectedResourceAccess(courseId:string, lessonId: string): Observable<ProtectedResourceAccess> {

    const params = new HttpParams()
      .set("tenantId", this.tenant.id)
      .set("courseId", courseId)
      .set("lessonId", lessonId);

    return this.http.get<ProtectedResourceAccess>(environment.api.resourceAccessUrl, {params});
  }



  saveProtectedResource(courseId:string, lessonId:string, changes: Partial<ProtectedResourceAccess>): Observable<any> {

    const resourcePath = `schools/${this.tenant.id}/courses/${courseId}/protectedResources/${lessonId}`;

    return from(setDoc(doc(this.firestore, resourcePath), changes, {merge: true}));

  }


}
